const mEditionBillingMyPaymentModalChangePlan = {
  mEditionBillingMyPaymentModalChangePlan: {
    alerts: {
      cupon: {
        gratis: 'Codigo Gratuito, no aplicable en cambio de plan',
        error: 'Código descuento inexistente!',
        success: 'Código descuento aplicado exitosamente!'
      },

      changePlan: {
        error: 'Un error ha ocurrido. Verifica los datos y vuelve a intentarlo.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CONFIRMAR',

    checkCupon: '¿Tienes código de descuento?',
    checkFacturaCompleta: '¿Necesitas factura completa?',
    checkFactura: '¿Necesitas Factura A?',

    inputs: {
      cupon: {
        placeholder: 'Código Descuento'
      },

      codigo_postal: {
        placeholder: 'Código Postal'
      },

      documento_tipo: {
        placeholder: 'Tipo de Documento'
      },

      documento_numero: {
        placeholder: 'Número de Documento'
      },

      localidad: {
        placeholder: 'Ciudad'
      },

      direccion: {
        placeholder: 'Mi Dirección'
      },

      persona: {
        empresa: {
          label: 'Empresa, Profesional o Autónomo'
        },

        particular: {
          label: 'Particular'
        }
      }
    },

    lblTotal: 'Estarás pagando',

    validation: {
      cliente: {
        codigo_postal: {
          required: 'Código Postal requerido.'
        },

        direccion: {
          maxLength: 'La longitud máxima 120 caracteres.',
          minLength: 'La longitud mínima 5 caracteres.',
          required: 'Dirección requerido.'
        },

        documento_numero: {
          maxLength: 'La longitud máxima 30 caracteres.',
          minLength: 'La longitud mínima 3 caracteres.',
          required: 'Número de Documento requerido.'
        },

        documento_tipo: {
          required: 'Tipo de Documento requerido.'
        },

        localidad: {
          maxLength: 'La longitud máxima 60 caracteres.',
          required: 'Ciudad requerida.'
        }
      }
    }
  }
}

export default mEditionBillingMyPaymentModalChangePlan
